/* eslint-disable react/jsx-filename-extension */
/* eslint-disable jsx-a11y/aria-role */
import DepartmentSelect from '@components/DepartmentSelect/DepartmentSelect';
import UserSelect from '@components/UserSelect/UserSelect';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from '@material-ui/core';
import ErrorOutlineRoundedIcon from '@material-ui/icons/ErrorOutlineRounded';
import { AgentChatTransferStatus } from '@src/model/frontendmodel';
import { Component } from 'react';
import { injectIntl } from 'react-intl';
import './ChatTransferAgentsPicker.css';
import { departmentWithoutAgents } from './Utils';

import _ from 'lodash';

class ChatTransferAgentsPicker extends Component {
  buildEmptyTargetBizProcess = () => ({
    botId: null,
  });

  // eslint-disable-next-line react/state-in-constructor
  state = {
    sourceAgent: { id: null, fullName: null },
    targetBizProcess: this.buildEmptyTargetBizProcess(),
    // eslint-disable-next-line react/no-unused-state
    targetAgents: [],
    targetAgent: { id: null, fullName: null },
    requestDialogComments: '',
  };

  constructor(props) {
    super(props);

    this.state.sourceAgent = {
      id: props.userId,
      fullName: window.store.getState().loginAuthentication.success.fullName,
    };

    this.xferMsgInput = null;
  }

  componentDidUpdate(prevProps) {
    // Clear the transfer in course, if there is any, when the active chat chages
    if (
      _.get(prevProps, 'activeChat.id', null) !==
      _.get(this.props, 'activeChat.id', null)
    ) {
      this.setState({
        targetBizProcess: this.buildEmptyTargetBizProcess(),
        targetAgent: { id: null, fullName: null },
        requestDialogComments: '',
      });
    }
  }

  // eslint-disable-next-line no-shadow
  handleDepartmentChange = (_, value) => {
    const { fetchUsers } = this.props;
    const isDepWithoutAgentsSelected =
      value.botId === departmentWithoutAgents.botId;

    if (!value.botId && !isDepWithoutAgentsSelected) return;

    fetchUsers();
    window.setTimeout(() => {
      this.setState({
        targetBizProcess: {
          ...value,
          _id: value.id,
          id: value.departmentId,
        },
        targetAgent: { id: null, fullName: null },
      });
    }, 1000);
  };

  handleAgentChange = (e, value) => {
    if (!value.id) return;

    this.setState({
      targetBizProcess: this.buildEmptyTargetBizProcess(),
      targetAgent: value,
    });
  };

  onChangeTargetAgent = (ev, value) => {
    this.setState({
      targetAgent: value,
    });
  };

  onRequestDialogCommentsChange = e => {
    this.setState({
      requestDialogComments: e.target.value,
    });
  };

  onRequestDialogCancel = () => {
    const { onCancel } = this.props;
    this.setState({
      requestDialogComments: '',
      targetBizProcess: this.buildEmptyTargetBizProcess(),
      targetAgent: { id: null, fullName: null },
    });
    onCancel();
  };

  onRequestDialogTransfer = () => {
    const {
      targetBizProcess,
      requestDialogComments,
      sourceAgent,
      targetAgent,
    } = this.state;
    const { activeChat, onRequestAgentChatTransfer } = this.props;

    const transfer = {
      chatId: activeChat.id,
      status: AgentChatTransferStatus.REQUESTED,
      comments: requestDialogComments,
      sourceAgent,
      targetAgent,
      targetBizProcessNode: {
        id: targetBizProcess.departmentId,
        code: targetBizProcess.departmentCode,
        name: targetBizProcess.name,
      },
    };

    onRequestAgentChatTransfer(transfer);

    this.setState({
      requestDialogComments: '',
      targetBizProcess: this.buildEmptyTargetBizProcess(),
      targetAgent: { id: null, fullName: null },
    });
  };

  filterStandardDepartment = option =>
    option.type !== 'STANDARD' && (option.childrens?.length || 0) === 0;

  filterTargetAgents = option => {
    const { userId } = this.props;
    const { targetBizProcess } = this.state;
    const { departmentId } = targetBizProcess;

    if (option.id === userId) return false;

    return departmentId === departmentWithoutAgents.departmentId
      ? option.departments.length === 0
      : !!option.departments.find(dep => dep.departmentId === departmentId);
  };

  filterCurrentAgent = option => {
    const { userId } = this.props;
    return userId !== option.id;
  };

  render() {
    const {
      intl: { formatMessage },
      areThereAgentsWithoutDepartment,
      departmentsState,
      activeChat,
    } = this.props;

    const { targetBizProcess, targetAgent, requestDialogComments } = this.state;

    let disabledPicker = !activeChat;

    if (activeChat != null && activeChat.chatXferRequest != null) {
      const transfer = activeChat.chatXferRequest;
      if (transfer.status !== AgentChatTransferStatus.CANCELLED) {
        disabledPicker = true;
      }
      if (transfer.status === AgentChatTransferStatus.REJECTED) {
        disabledPicker = false;
      }
    }

    const areAgentsWithoutDepartments =
      targetBizProcess?.id === departmentWithoutAgents.departmentId;

    const disableList =
      areAgentsWithoutDepartments && !areThereAgentsWithoutDepartment;

    return (
      // eslint-disable-next-line react/jsx-filename-extension

      <Dialog open fullWidth maxWidth="xs">
        <DialogTitle>
          {formatMessage({
            id: 'ChatTransfer.agentsPickerRequestDialogTitle',
          })}
        </DialogTitle>
        <DialogContent>
          <Box display="flex" flexDirection="column" style={{ gap: '24px' }}>
            {disableList && (
              <Box className="no-agents">
                <ErrorOutlineRoundedIcon style={{ color: '#ffcf33' }} />
                <Typography>
                  {formatMessage({
                    id: 'Console.Transfer.AgentsWithoutDepartment.Title',
                  })}
                </Typography>
              </Box>
            )}
            <Box>
              {departmentsState === 'ACTIVE' ? (
                <DepartmentSelect
                  name="selectTargetToXfer"
                  placeholder={formatMessage({
                    id: 'ChatTransfer.agentsPicker',
                  })}
                  value={
                    _.isNumber(targetBizProcess?.botId)
                      ? targetBizProcess
                      : null
                  }
                  onChange={this.handleDepartmentChange}
                  filterOptions={this.filterStandardDepartment}
                  disabled={disabledPicker}
                  disableInactiveOptions
                  fullWidth
                />
              ) : (
                <UserSelect
                  name="selectTargetToXfer"
                  placeholder={formatMessage({
                    id: 'ChatTransfer.chooseTargetAgent',
                  })}
                  value={targetAgent?.id ? targetAgent : null}
                  onChange={this.handleAgentChange}
                  disableInactiveOptions
                  role="AGENT"
                  useOnlineStatus
                  disabled={disabledPicker}
                  filterOptions={this.filterCurrentAgent}
                  fullWidth
                />
              )}
            </Box>

            {departmentsState === 'ACTIVE' && (
              <Box>
                <UserSelect
                  name="selectTargetUser"
                  placeholder={formatMessage({
                    id: 'ChatTransfer.chooseTargetAgent',
                  })}
                  value={targetAgent?.id ? targetAgent : null}
                  filterOptions={this.filterTargetAgents}
                  onChange={this.onChangeTargetAgent}
                  disableInactiveOptions
                  role="AGENT"
                  useOnlineStatus
                  fullWidth
                  disabled={
                    disableList ||
                    (!targetBizProcess?.id && !areAgentsWithoutDepartments)
                  }
                />
              </Box>
            )}

            <Box>
              <Typography>
                {formatMessage({
                  id: 'ChatTransfer.agentsPickerRequestDialogReasonLabel',
                })}
              </Typography>
              <TextField
                id="ChatTransfer.agentsPickerRequestDialogReasonLabel"
                multiline
                minRows={2}
                maxRows={4}
                variant="outlined"
                margin="dense"
                InputLabelProps={{ shrink: true }}
                fullWidth
                value={requestDialogComments}
                onChange={this.onRequestDialogCommentsChange}
                style={{ marginTop: '8px' }}
              />
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button color="primary" variant="outlined" onClick={this.onRequestDialogCancel}>
            {formatMessage({
              id: 'ChatTransfer.agentsPickerRequestDialogCancel',
            })}
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={this.onRequestDialogTransfer}
            disabled={
              !requestDialogComments ||
              requestDialogComments.length === 0 ||
              !targetAgent ||
              _.isNil(targetAgent.id)
            }
          >
            {formatMessage({
              id: 'ChatTransfer.agentsPickerRequestDialogTransfer',
            })}
          </Button>
        </DialogActions>
      </Dialog>
    );
  }
}

export default injectIntl(ChatTransferAgentsPicker);
